import { F33Crud } from './f33.model';
import { SortType } from './sortType.model';
import { Image } from './image.model';
import { Guid } from 'typescript-guid';
import { DateType } from '../enums/date-type';
import { UserType } from '../enums/user-type';

export class SubstationCrud {
  id!: number;
  name!: string;
  number!: string;
  feeders!: F33Crud[];
  feedersNames!: string;
  utilityId!: number;
  feederIds!: number[];
  guid!: string;
  code!: string;
}

export class SubstationCrudCreate {
  id!: number;
  name!: string;
  number!: string;
  feedersIds!: number[];
  utilityId!: number;
}

export class TaggedSubstation {
  id: number;
  name?: string;
  address: string;
  number?: string;
  incomingFeeders: number;
  outgoingFeeders: number;
  connectedTransformers: number;
  code: string;
  areaId?: number;
  region: string;
  area: string;
  guid: Guid;
  dtId?: number;
  slrn?: string;
  status?: string;

  constructor(init?: Partial<TaggedSubstation>) {
    this.id = init?.id ?? 0;
    this.name = init?.name;
    this.address = init?.address ?? '';
    this.number = init?.number;
    this.incomingFeeders = init?.incomingFeeders ?? 0;
    this.outgoingFeeders = init?.outgoingFeeders ?? 0;
    this.connectedTransformers = init?.connectedTransformers ?? 0;
    this.code = init?.code ?? '';
    this.areaId = init?.areaId;
    this.region = init?.region ?? '';
    this.area = init?.area ?? '';
    this.dtId = init?.dtId;
    this.slrn = init?.slrn;
    this.status = init?.status;
    this.guid = init?.guid ?? Guid.create();
  }
}

export class SubstationFilter {
  search: string = '';
  filterBy: string = '';
  userType: UserType | null = null;
  sortBy: SortType = SortType.NEWEST;
  dateFrom: string | null = null;
  dateTo: string | null = null;
  dateType: DateType = DateType.LastUpdateTime;
  selectedAreas: number[] = [];
  status: number | null = null;
  type: number | null = null;
  selectedIds: number[] = [];
  selectedUsers: number[] = [];
  selectedTransmissionStations: number[] = [];
}

export class SubstationAppliedFilter {
  id?: number;
  label: string = '';
  value: any = '';
}

export enum SubstationStatsOptions {
  Total = 1,
  IncomingFeeders = 2,
  OutgoingFeeders = 3,
  Retagged = 4,
  Transformers = 5,
}

export class SubstationStats {
  total: number = 0;
  incomingFeeders: number = 0;
  outgoingFeeders: number = 0;
  retagged: number = 0;
  transformers: number = 0;

  constructor(data?: any) {
    this.total = data?.total;
    this.incomingFeeders = data?.numberOf11KvFeeders;
    this.outgoingFeeders = data?.retagged;
    this.retagged = data?.lvReticulation;
    this.transformers = data?.goodCondition;
  }
}


export class EditSubstation {
  id!: number;
  slrn!: string;
  name?: string;
  number?: string;
  tsName!: string;
  mainFeederNames!: string[];
  mainFeederNumbers!: string;
  subFeederNames!: string;
  areaName!: string;
  areaId!: number;
  regionName!: string;
  longitude!: number;
  latitude!: number;
  firstCapturedUser!: string;
  lastUpdatedUser!: string;
  lastUpdateTime!: string;
  creationDate!: string;
  auditedBy: string = '';
  auditedDateTime!: string;
  auditedStatus: string = '';
  numberOfOutgoingFeeders!: number;
  numberOfIncomingFeeders!: number;
  images!: Image[];
  reassignedBy: string = '';
  assignedBy: string = '';
  dataQualityStatus: string = '';
  validatedBy: string = '';
  validationDate: string = '';
  connectedDts!: number;
  connectedMvPoles!: number;
  connectedLvPoles!: number;
  reviewStatus: string = '';
  status: string = '';
  assignedUserId: number = 0;
  dataQualityId: number = 0;
  guid!: string;

  constructor(data?: any) {
    if (data) {
      this.id = data.id ?? 0;
      this.slrn = data.slrn;
      this.name = data.name ?? "";
      this.number = data.number ?? "";
      this.tsName = data.tsName ?? "";
      this.mainFeederNames = data.mainFeederNames ?? [];
      this.mainFeederNumbers = data.mainFeederNumbers ?? [];
      this.subFeederNames = data.subFeederNames ?? "";
      this.areaName = data.areaName ?? "";
      this.areaId = data.areaId ?? 0;
      this.regionName = data.regionName ?? "";
      this.longitude = data.longitude ?? 0;
      this.latitude = data.latitude ?? 0;
      this.firstCapturedUser = data.firstCapturedUser ?? "";
      this.lastUpdatedUser = data.lastUpdatedUser ?? "";
      this.lastUpdateTime = data.lastUpdateTime ?? "";
      this.creationDate = data.creationDate ?? "";
      this.numberOfIncomingFeeders = data.numberOfIncomingFeeders ?? 0;
      this.numberOfOutgoingFeeders = data.numberOfOutgoingFeeders ?? 0; 
      this.images = data?.images?.length
        ? data?.images.map((el: any) => new Image(el))
        : [];
      this.reassignedBy = data.reassignedBy ?? "";
      this.assignedBy = data.assignedBy ?? "";
      this.auditedStatus = data.auditedStatus ?? "";
      this.dataQualityStatus = data?.dataQualityStatus ?? '';
      this.validatedBy = data?.validatedBy ?? '';
      this.validationDate = data?.validationDate ?? '';
      this.connectedDts = data?.connectedDts ?? 0;
      this.connectedLvPoles = data?.connectedLvPoles ?? 0;
      this.connectedMvPoles = data?.connectedMvPoles ?? 0;
      this.reviewStatus = data?.reviewStatus ?? '';
      this.status = data?.status ?? '';
      this.assignedUserId = data?.assignedUserId ?? 0;
      this.dataQualityId = data?.dataQualityId ?? 0;
      this.auditedBy = data?.auditedBy ?? '';
      this.auditedDateTime = data?.auditedDateTime ?? '';
      this.guid = data?.guid ?? Guid.create();
    }
  }
}
